import {camelCase} from '@servicenow/ui-internal';

export default function getOperationName(tagName) {
	return camelCase(tagName.toLowerCase());
}
